import { render, staticRenderFns } from "./PacienteComum.vue?vue&type=template&id=4e244c05&scoped=true"
import script from "./PacienteComum.vue?vue&type=script&lang=js"
export * from "./PacienteComum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e244c05",
  null
  
)

export default component.exports